import { DropDownItem, GenerateDropDownItems, SearchByItem } from "@app/shared/classes/general";
import { TableColumnDef } from "@app/shared/components/smart-data-grid/data-grid/data-grid.constants";
import { smartSearchType } from "@app/shared/components/smart-search-form/smart-search-form.constant";
import { CountryCodeTranslate } from "@app/shared/pipes/country-code-translate";
import { LocaleDate } from "@app/shared/pipes/locale-date";
import { YearMonth } from "@app/shared/pipes/year-month";
import { SubRegion } from "@app/shared/classes/subRegion";
import { CommonFieldName, CommonFieldLabel } from "@app/shared/constants";
import { DynamicTranslate } from "@app/shared/pipes/dynamic-translate";
import { GenerateKpiDropDownItems, Kpi } from "@app/shared/classes/kpi";

export enum EconomyFieldName {
  fullName = "fullName",
  terminalId = "terminalId",
  terminalName = "terminalName",
  subRegionName = "subRegionName",
  country = "country",
  kpiName = "kpiName",
  kpi_Translation_Id = "kpi_Translation_Id",
  kpiDate = "kpiDate",
  score = "score",
  kpiValue = "kpiValue",
  reference = "reference",
  created_On = "created_On",
  created_By = "created_By",
  lastModified_On = "lastModified_On",
  lastModified_By = "lastModified_By",

  apexId = "apexId",
  kpiValueWithUom = "kpiValueWithUom",

  rowNum = "rowNum",
  errorMessage = "errorMessage"
};

enum FieldLabel {
  DRIVER_NAME = "ml_143908",
  TERMINAL = "ml_144113",
  TERMINAL_ID = "ml_143909",
  TERMINAL_NAME = "ml_143910",
  SUB_REGION = "ml_143911",
  COUNTRY = "ml_143912",
  KPI_NAME = "ml_143913",
  YEAR_AND_MONTH = "ml_143914",
  SCORE = "ml_143969",
  VALUE = "ml_143970",
  REFERENCE = "ml_147001",
  CREATED_BY = "ml_143916",
  CREATED_ON = "ml_143917",
  LAST_CHANGED_BY = "ml_143918",
  LAST_CHANGED_ON = "ml_143919",

  DRIVER_APEX_ID = "ml_143930",

  LINE_NUMBER = "ml_143953",
  IMPORT_FAILED_MESSAGE = "ml_143954"
}

export const DataGridColumnDef: TableColumnDef[] = [
  {
    text: FieldLabel.DRIVER_NAME,
    name: EconomyFieldName.fullName,
    sort: true
  },
  {
    text: FieldLabel.TERMINAL_ID,
    name: EconomyFieldName.terminalId,
    sort: true,
  },
  {
    text: FieldLabel.TERMINAL_NAME,
    name: EconomyFieldName.terminalName,
    sort: true
  },
  {
    text: FieldLabel.SUB_REGION,
    name: EconomyFieldName.subRegionName,
    sort: true
  },
  {
    text: FieldLabel.COUNTRY,
    name: EconomyFieldName.country,
    sort: true,
    pipe: CountryCodeTranslate
  },
  {
    text: FieldLabel.KPI_NAME,
    name: EconomyFieldName.kpi_Translation_Id,
    sort: true,
    pipe: DynamicTranslate
  },
  {
    text: FieldLabel.YEAR_AND_MONTH,
    name: EconomyFieldName.kpiDate,
    sort: true,
    pipe: YearMonth
  },
  {
    text: FieldLabel.VALUE,
    name: EconomyFieldName.kpiValueWithUom,
    sort: true,
    sortFieldName: EconomyFieldName.kpiValue
  },
  {
    text: FieldLabel.SCORE,
    name: EconomyFieldName.score,
    sort: true,
  },
  {
    text: FieldLabel.REFERENCE,
    name: EconomyFieldName.reference,
    sort: true,
  },
  {
    text: FieldLabel.CREATED_BY,
    name: EconomyFieldName.created_By,
    sort: true
  },
  {
    text: FieldLabel.CREATED_ON,
    name: EconomyFieldName.created_On,
    sort: true,
    pipe: LocaleDate
  },
  {
    text: FieldLabel.LAST_CHANGED_BY,
    name: EconomyFieldName.lastModified_By,
    sort: true
  },
  {
    text: FieldLabel.LAST_CHANGED_ON,
    name: EconomyFieldName.lastModified_On,
    sort: true,
    pipe: LocaleDate
  }
]

const EconomySearchByList: SearchByItem[] = [
  { searchBy: EconomyFieldName.apexId, searchByLabel: FieldLabel.DRIVER_APEX_ID },
  { searchBy: EconomyFieldName.fullName, searchByLabel: FieldLabel.DRIVER_NAME },
  { searchBy: EconomyFieldName.terminalId, searchByLabel: FieldLabel.TERMINAL, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: EconomyFieldName.subRegionName, searchByLabel: FieldLabel.SUB_REGION, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: EconomyFieldName.kpiName, searchByLabel: FieldLabel.KPI_NAME, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  {
    searchBy: EconomyFieldName.kpiDate, searchByLabel: FieldLabel.YEAR_AND_MONTH, searchByType: smartSearchType.singleSelect,
    searchDropDownValue: [{ value: 1, label: "ml_143943" }, { value: 3, label: "ml_143944" }, { value: 6, label: "ml_143945" }, { value: 12, label: "ml_143946" }]
  },
  { searchBy: CommonFieldName.lastModified_By, searchByLabel: CommonFieldLabel.LAST_CHANGED_BY },
  { searchBy: CommonFieldName.lastModified_On, searchByLabel: CommonFieldLabel.LAST_CHANGED_ON, searchByType: smartSearchType.dateRangeSelct }
];

export const GetEconomySearchByList = ([terminals, subRegions, kpis, userCountry]: [DropDownItem[], SubRegion[], Kpi[], string]) => {
  var result = EconomySearchByList.slice();
  result[2].searchDropDownValue = terminals;
  result[3].searchDropDownValue = subRegions ? GenerateDropDownItems(subRegions.map(item => item.subRegionName)) : [];
  result[4].searchDropDownValue = GenerateKpiDropDownItems(
    kpis.filter(kpi => kpi && kpi.kpiConfigurations && kpi.kpiConfigurations.filter(config => config && config.country === userCountry).length > 0));
  return result;
}
